import { render, staticRenderFns } from "./kdxCopyText.g.vue?vue&type=template&id=1243cdab&scoped=true"
import script from "./kdxCopyText.g.vue?vue&type=script&lang=js"
export * from "./kdxCopyText.g.vue?vue&type=script&lang=js"
import style0 from "./kdxCopyText.g.vue?vue&type=style&index=0&id=1243cdab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1243cdab",
  null
  
)

export default component.exports